import React from 'react'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import BoxCardXL from './BoxCardXL'
import BoxCardXS from './BoxCardXS'

export default function BoxCard ({ box, type, currentBox, setCurrentBox }) {
  const screens = useBreakpoint()

  return (
    <>
      { screens.lg && <BoxCardXL box={box} type={type} currentBox={currentBox} setCurrentBox={setCurrentBox} /> }
      { !screens.lg && <BoxCardXS box={box} type={type} currentBox={currentBox} setCurrentBox={setCurrentBox} /> }
    </>
  )
}
